module.exports = __webpack_public_path__ + "static/media/quiz-hint-1-en-1080p.e858b1b6.mp4";